import CommonUser from '../commons/User'
import DocumentSession from './Session'

export default class DocumentUser extends CommonUser {
  constructor (data) {
    super(data)
    this.session = new DocumentSession()
  }
}
